module.exports = __webpack_public_path__ + "assets/drain-off-valve.54db8f3f.svg";